<template>
    <div class="col-12">
        <Field v-model="formData.params.group" :errorMessage="errorMessages.group" :label="i18n('AD Group')"
            :disabled="submitted" :type="readonly ? 'readonly' : 'text'" />
    </div>
</template>

<script>
import Field from "@/components/common/form/Field.vue";

export default {
    components: {
        Field,
    },
    data() {
        return {
            // Component data
        };
    },
    props: {
        submitted: {
            type: Boolean,
            required: true
        },
        readonly: {
            type: Boolean,
            required: true
        },
        formData: {
            type: Object,
            required: true
        },
        errorMessages: {
            type: Object,
            required: true
        },
    },
    methods: {}
};
</script>
